import { render } from "./CompanyProfit.vue?vue&type=template&id=125cdc71&scoped=true"
import script from "./CompanyProfit.vue?vue&type=script&lang=js"
export * from "./CompanyProfit.vue?vue&type=script&lang=js"

import "./CompanyProfit.vue?vue&type=style&index=0&id=125cdc71&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125cdc71"]])

export default __exports__